<template>
    <div>
        <div class="paymentBox">
            <div class="h2" v-if="!noTitle">
                Payment Method
            </div>
            <div v-if="isAvailable && !cart.appleGooglePayResponce" class="agpayBox d-flex align-items-center" @click="getGoogleApplePay">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                        fill="#CF3339"/>
                </svg>
                <span class="h5">Pay with:</span>
                <img class="apay" v-if="devicetype.ios" :src="getStaticImage('icons/payment/apple_pay.png')" alt="" style="">
                <img class="gpay" v-if="devicetype.windows || devicetype.android" :src="getStaticImage('icons/payment/google_pay.png')" alt="">
            </div>
            <div v-if="cart.appleGooglePayResponce" class="usegiftpoints custom-control custom-checkbox agpayBox d-flex align-items-center " @click="unCheckAppleGooglePay">
                <input type="checkbox" :checked="1" class="custom-control-input" name="useGift" id="applBal">
                <label class="custom-control-label applBal d-flex align-items-center" for="applBal">
                    <span class="h5">Paying with:</span>
                    <img class="apay" v-if="devicetype.ios" :src="getStaticImage('icons/payment/apple_pay.png')" alt="">
                    <img class="gpay" v-if="devicetype.windows || devicetype.android" :src="getStaticImage('icons/payment/google_pay.png')" alt="">
                </label>
            </div>
            <div class="cartList" v-if="cards">
                <div
                    class="cart"
                    :class="{active: card.credit_card_id === cart.card.credit_card_id}"
                    v-for="(card, index) in cards"
                    @click="$store.commit('cart/setCard', card)"
                >
                    <div v-if="user" class="closeIcon" @click.prevent="removeCard(index)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.98026 0.971802C3.3956 0.971802 0.498047 3.8049 0.498047 7.30983C0.498047 10.8148 3.3956 13.6479 6.98026 13.6479C10.5649 13.6479 13.4625 10.8148 13.4625 7.30983C13.4625 3.8049 10.5649 0.971802 6.98026 0.971802ZM10.2214 9.58518L9.30738 10.4788L6.98026 8.20349L4.65315 10.4788L3.73915 9.58518L6.06627 7.30983L3.73915 5.03448L4.65315 4.14082L6.98026 6.41617L9.30738 4.14082L10.2214 5.03448L7.89425 7.30983L10.2214 9.58518Z"
                                fill="white"/>
                        </svg>
                    </div>
                    <div class="cartType">
                        <i :class="cardBrandClass[card.card_type.toLowerCase()]"></i>
                    </div>
                    <div class="cartNumber caption">
                        Card ending in {{card.credit_card_number.slice(-4)}}
                    </div>
                    <div class="cartNameExpBox caption">
                        <div class="name">
                            {{ card.name_on_card }}
                        </div>
                        <div class="date">
                            {{ card.expiration_date.substring(0, 2) }}/{{ card.expiration_date.substring(2, 4) }}
                        </div>
                    </div>
                </div>
            </div>
            <router-link :to="{name: 'AddCredit'}" class="addCard">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                        fill="#CF3339"/>
                </svg>
                <span class="h4">Add a new Debit/Credit Card</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CartPaymentsOption",
        props: ["noTitle", "forGiftCards"],
        data() {
            return {
                cards: null,
                cardBrandClass: {
                    'visa': 'fab fa-cc-visa',
                    'mastercard': 'fab fa-cc-mastercard',
                    'americanexpress': 'fab fa-cc-amex',
                    'discover': 'fab fa-cc-discover',
                    'diners': 'fab fa-cc-diners-club',
                    'jcb': 'fab fa-cc-jcb',
                    'unknown': 'fa fa-credit-card',
                },
                devicetype: this.$device,
                isAvailable: null,
               
            }
        },
        created() {
            this.initCards();
            this.googleApplePayCheck();
            console.log("DEVICE##########"+window.cordova?.platformId);
        },
        methods: {
            async googleApplePayCheck(){
                if( window.cordova?.platformId == "android" ){
                    return this.isAvailable = false
                }
                this.isAvailable = await window.cordova?.plugins.ApplePayGooglePay.canMakePayments();
            },
            getGoogleApplePay(){
                let request = {
                    merchantId: 'merchant.com.kettlemans',
                    purpose: `Payment for your kettlemans order`,
                    amount: parseFloat(this.cart.total()),
                    countryCode: "CA",
                    currencyCode: "CAD"
                };
                if( window.cordova?.platformId == "android" ){
                    request = {
                        merchantId: '451311376001',
                        purpose: `Payment for your kettlemans order`,
                        amount: parseFloat(this.cart.total()),
                        countryCode: "CA",
                        currencyCode: "CAD",
                        gateway: 'authorizenet',
                        gpMerchantName: 'Ontario 2551194',
                        gpMerchantId: 'BCR2DN6TZ6XO5KLG'
                    };
                }
                console.log( request );
                window.cordova?.plugins.ApplePayGooglePay.makePaymentRequest(request, r => {
                        if(r){
                            this.$store.commit("cart/setGoogleApplePay", btoa(r));
                            this.$store.commit("cart/setGoogleApplePayMethod", window.cordova?.platformId !== "android" ? 'google_pay' : 'apple_pay' );
                            this.$store.commit('cart/setCard', null);
                        }
                    },
                    err => {
                        console.log("Error:"+err);
                        this.$store.commit("shared/setAlert", "Error:"+err);
                    }
                )
            },
            unCheckAppleGooglePay(){
                this.$store.commit("cart/setGoogleApplePayMethod", null);
                this.$store.commit("cart/setGoogleApplePay", null);
                if(this.cards){
                    this.$store.commit('cart/setCard', this.cards[0]);
                }
            },
            /*
            window.cordova?.plugins.ApplePayGooglePay.canMakePayments().then(data=>{
                this.isAvailable = data;
                console.log("#################this.isAvailable: "+this.isAvailable);
            });
            */
            initCards() {
                this.$store.dispatch("cart/getCreditCardList", {
                    callback: (cards) => {
                        if (cards) {
                            this.$store.commit("cart/setCard", cards[0]);
                        }
                        this.cards = cards
                    }
                });
            },
            removeCard(index) {
                this.$modal.show("promt-modal", {
                    title: "Warning!", content: "Are you sure you want to remove this card?", success: () => {
                        this.$store.dispatch("cart/deleteCreditCard", {
                                    id: this.cards[index].credit_card_id,
                                    callback: () => {
                                        this.cards.splice(index, 1);
                                        if (this.cards.length) {
                                            this.$store.commit('cart/setCard', this.cards[0])
                                        }else{
                                            this.$store.commit('cart/setCard', null)
                                        }
                                    }
                                }
                        );
                    }
                })
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart.cart;
            },
            gatewayInfo() {
                return this.$store.state.shared.gatewayInfo;
            }
        },
        watch: {
            "cart.updateDate": function (val) {
                if (val) {
                    this.initCards();
                }
            }
        }
    }
</script>
